<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -extra-width"
       [ngClass]="{'-is-open' : modalStatus,
                  '-is-closed': !modalStatus}">

  <div class="esf-main-sidebar__content" *ngIf="!loading">
    <h3 i18n='Customer data edit modal title@@tixxSelect.modalTitle.editQuotasPermissions'>Edit Quotas & Permissions</h3>
    <form [formGroup]="ticketQuotaForm" (ngSubmit)="updateFormSubmit(ticketQuotaForm)" id="ticketQuotaForm">

      <div app-form-field-select
           [control]="ticketQuotaForm.get('generalQuotaPresent')"
           [label]="flTranslations.i18nAllowPublicSubmissions"
           (valueChanged)="selectChanged($event, 'generalQuota')"
           [useNgValue]="true"
           [array]="yesOrNoDropdown">
      </div>

      <div app-form-field-stepper
           *ngIf="ticketQuotaForm.get('generalQuotaPresent')?.value"
           [control]="ticketQuotaForm.get('generalQuota')"
           [label]="flTranslations.i18nMaxTicketCountPerCustomer">
      </div>

      <div app-form-field-select
           [control]="ticketQuotaForm.get('activeMemberQuotaPresent')"
           [label]="flTranslations.i18nDeviatingMaxTicketCount"
           (valueChanged)="selectChanged($event, 'activeMemberQuota')"
           [useNgValue]="true"
           [array]="yesOrNoDropdown">
      </div>

      <div app-form-field-stepper
           *ngIf="ticketQuotaForm.get('activeMemberQuotaPresent')?.value"
           [min]="ticketQuotaForm.get('generalQuota').value ? ticketQuotaForm.get('generalQuota').value : 0"
           [control]="ticketQuotaForm.get('activeMemberQuota')"
           [label]="flTranslations.i18nMaxTicketCountForMembers">
      </div>

      <div app-form-field-select
           [control]="ticketQuotaForm.get('customerAttributeConstraintItemsPresent')"
           [label]="flTranslations.i18nDeviatingMaxTicketCountCustomerGroups"
           (valueChanged)="fillAttributes($event)"
           [useNgValue]="true"
           [array]="yesOrNoDropdown">
      </div>

      <ng-container *ngIf="ticketQuotaForm.get('customerAttributeConstraintItemsPresent')?.value">
        <label class="esf-form-item__label"> {{ flTranslations.i18nMaxTicketCountForSpecificCustomerGroups }}</label>
        <table class="esf-table" *ngIf="ticketQuota.customerAttributeConstraintItems">
          <thead class="esf-table__head">
            <tr class="esf-table__row">
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.attribute' data-label="Attribute">
                <span i18n='Table cell heading@@general.tableCellLabel.attribute' class="esf-table__cell-inner">Attribute</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.maxTicketCount' data-label="Max. Ticket Count">
                <span i18n='Table cell heading@@general.tableCellLabel.maxTicketCount' class="esf-table__cell-inner">Max. Ticket Count</span>
              </th>
            </tr>
          </thead>
          <tbody class="esf-table__body">
            <tr class="esf-table__row" *ngFor="let _ of attributes.controls;">
              <td class="esf-table__cell">
                <span class="esf-table__cell-inner">{{ _['controls']['attributeName'].value }}</span>
              </td>
              <td class="esf-table__cell">
                <span class="esf-table__cell-inner">
                  <div class="esf-form-item esf-form-item--small">
                    <div class="esf-stepper">
                      <div app-form-field-stepper
                           class="esf-form-item--small"
                           [min]="ticketQuotaForm.get('generalQuota').value ? ticketQuotaForm.get('generalQuota').value : 0"
                           [smallButtons]="true"
                           [control]="_['controls']['quota']">
                      </div>
                    </div>
                  </div>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>

    </form>
  </div>

  <div class="esf-main-sidebar__content" *ngIf="loading">
    <app-spinner [(show)]="loading"></app-spinner>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -extra-width"
     [ngClass]="{'-is-open': modalStatus}">
  <app-submit-row-buttons [form]="'ticketQuotaForm'"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="tixxSelectOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space -has-transition"
     (click)="tixxSelectOverviewService.toggleAllModal(false)"
     [ngClass]="{'-is-open': modalStatus}">
  <span class="esf-hamburger__icon"></span>
</div>
